import { StyledDesc } from "src/styled";

interface Props {
  desc: string;
  styles?: any;
  noscroll?: boolean;
}

const Div = ({ children }: any) => (
  <div style={{ width: "100%", textAlign: "left" }}>{children}</div>
);

const ChecklistDescription = ({ desc, styles, noscroll }: Props) => {
  const Wrapper = noscroll ? Div : StyledDesc;
  return (
    <Wrapper>
      {desc.split("\n").map((line, i) => (
        <span style={styles} key={`desc-c-${i}`}>
          {line}
          <br />
        </span>
      ))}
    </Wrapper>
  );
};
export default ChecklistDescription;
